export default __webpack_public_path__ + "static/media/noa-48.75e96b6d.jpg";